import React from "react";

export const GoogleIcon = (props) => (
  <svg viewBox="0 0 48 48" width="24px" height="24px" {...props}>
    <path
      fill="#FFC107"
      d="M43.611,20.083H42V20H24v8h11.303c-1.649,4.657-6.08,8-11.303,8c-6.627,0-12-5.373-12-12c0-6.627,5.373-12,12-12c3.059,0,5.842,1.154,7.961,3.039l5.657-5.657C34.046,6.053,29.268,4,24,4C12.955,4,4,12.955,4,24c0,11.045,8.955,20,20,20c11.045,0,20-8.955,20-20C44,22.659,43.862,21.35,43.611,20.083z"
    />
    <path
      fill="#FF3D00"
      d="M6.306,14.691l6.571,4.819C14.655,15.108,18.961,12,24,12c3.059,0,5.842,1.154,7.961,3.039l5.657-5.657C34.046,6.053,29.268,4,24,4C16.318,4,9.656,8.337,6.306,14.691z"
    />
    <path
      fill="#4CAF50"
      d="M24,44c5.166,0,9.86-1.977,13.409-5.192l-6.19-5.238C29.211,35.091,26.715,36,24,36c-5.202,0-9.619-3.317-11.283-7.946l-6.522,5.025C9.505,39.556,16.227,44,24,44z"
    />
    <path
      fill="#1976D2"
      d="M43.611,20.083H42V20H24v8h11.303c-0.792,2.237-2.231,4.166-4.087,5.571c0.001-0.001,0.002-0.001,0.003-0.002l6.19,5.238C36.971,39.205,44,34,44,24C44,22.659,43.862,21.35,43.611,20.083z"
    />
  </svg>
);

export const MicrosoftIcon = (props) => (
  <svg viewBox="0 0 23 23" width="24px" height="24px" {...props}>
    <path fill="#f35325" d="M1 1h10v10H1z" />
    <path fill="#81bc06" d="M12 1h10v10H12z" />
    <path fill="#05a6f0" d="M1 12h10v10H1z" />
    <path fill="#ffba08" d="M12 12h10v10H12z" />
  </svg>
);

export const OrcidIcon = (props) => (
  <svg viewBox="0 0 256 256" width="24px" height="24px" {...props}>
    <path
      fill="#A6CE39"
      d="M256,128c0,70.7-57.3,128-128,128C57.3,256,0,198.7,0,128C0,57.3,57.3,0,128,0C198.7,0,256,57.3,256,128z"
    />
    <path fill="#FFFFFF" d="M86.3,186.2H70.9V79.1h15.4v48.4V186.2z" />
    <path
      fill="#FFFFFF"
      d="M81.7,67.6c-4.7,0-8.5-3.8-8.5-8.5s3.8-8.5,8.5-8.5c4.7,0,8.5,3.8,8.5,8.5S86.4,67.6,81.7,67.6z"
    />
    <path
      fill="#FFFFFF"
      d="M214.5,134.9c0-14.7-2.9-26.2-9-34.6c-6.1-8.5-14.9-12.8-26.4-12.8h-41.2v98.7h41.7c11.4,0,20-4.3,25.9-12.8C211.7,164.6,214.5,151.7,214.5,134.9z M186.6,163.6h-21.7v-66.9h22.2c6.2,0,10.6,1.4,13.2,4.1c2.6,2.8,3.9,7.6,3.9,14.6v35.3c0,6.5-1.3,11.1-3.9,13.8C197.6,161.9,193.1,163.6,186.6,163.6z"
    />
  </svg>
);
